import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isLoggedIn } from "../api/auth";

function RequireAuth(props) {
    var location = useLocation();

    if (!isLoggedIn()) {
        return <Navigate to="/login" replace state={{ from: location.pathname }} />;
    }
    return props.children;
}

export default RequireAuth;
